import { jsxs as S, jsx as m, Fragment as mt } from "react/jsx-runtime";
import { c as dt } from "react/compiler-runtime";
import { Box as C, Typography as N, Button as Ue } from "@mui/material";
import ft from "@mui/icons-material/EventOutlined";
import vt from "@mui/icons-material/KeyboardArrowDownOutlined";
import { styles as c } from "./DateTimeSelect.style.js";
import { useState as L, useLayoutEffect as ht } from "react";
import { AnchorDropdownMenu as Re } from "./AnchorDropdownMenu.js";
import { LiveDataPresetsMenu as Dt } from "./LiveDataPresetsMenu.js";
import { DateTimeSelectorMenu as Xe } from "./DateTimeSelectorMenu.js";
import s from "moment-timezone";
import { generateTimeSlots as pt, formatPresetLabel as xt, calculateDateRange as I } from "../../../utilities/datetime.js";
import { Seek as Ze } from "./Seek.js";
import { useInterval as bt } from "../../../utilities/index.js";
const Ot = [{
  label: "Last 15 Mins",
  value: "15minute"
}, {
  label: "Last 30 Mins",
  value: "30minute"
}, {
  label: "Last 1 Hour",
  value: "1hour"
}, {
  label: "Last 3 Hours",
  value: "3hours"
}, {
  label: "Last 6 Hours",
  value: "6hours"
}, {
  label: "Last 24 Hours",
  value: "24hours"
}, {
  label: "Last 7 Days",
  value: "7days"
}, {
  label: "Last 30 Days",
  value: "30days"
}, {
  label: "Last 90 Days",
  value: "90days"
}, {
  label: "Last 1 Year",
  value: "1year"
}, {
  label: "Custom",
  value: "custom"
}], Et = (et) => {
  const e = dt(139), {
    startTime: p,
    endTime: x,
    interval: _,
    timeSlotInterval: Ee,
    hideTime: Pe,
    options: Ye,
    hideSeek: Fe,
    hideRange: we,
    rangesOnly: He,
    deltaChangePercent: Ne,
    minTime: We,
    maxTime: je,
    timezone: W,
    onChange: j,
    onRefresh: Ce,
    isLive: $e,
    disablePresetFiltering: Ke,
    refreshInterval: Ve,
    autoApply: qe
  } = et, Te = Ee === void 0 ? 15 : Ee, M = Pe === void 0 ? !1 : Pe, T = Ye === void 0 ? Ot : Ye, $ = Fe === void 0 ? !1 : Fe, g = we === void 0 ? !1 : we, f = He === void 0 ? !1 : He, tt = Ne === void 0 ? 0.5 : Ne, v = We === void 0 ? 0 : We, b = je === void 0 ? 1 / 0 : je;
  let K;
  e[0] !== W ? (K = W === void 0 ? s.tz.guess() : W, e[0] = W, e[1] = K) : K = e[1];
  const a = K, d = $e === void 0 ? !1 : $e, at = Ke === void 0 ? !1 : Ke, lt = Ve === void 0 ? 6e4 : Ve, z = qe === void 0 ? !1 : qe, [A, Ge] = L(null), [V, ge] = L(null), [q, Je] = L(null), [G, Qe] = L(null);
  let J;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (J = {
    label: "Custom",
    value: "custom"
  }, e[2] = J) : J = e[2];
  const [l, B] = L(J);
  let Q;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Q = s().subtract(7, "days").unix(), e[3] = Q) : Q = e[3];
  const [r, h] = L(Q);
  let U;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (U = s().unix(), e[4] = U) : U = e[4];
  const [o, D] = L(U), [X, O] = L(!1), [ze, y] = L(!d);
  let Se;
  if (at)
    Se = T;
  else {
    let t, n;
    if (e[5] !== b || e[6] !== v) {
      const H = b === 1 / 0 ? s().add(100, "years").unix() : b;
      let k;
      e[9] !== v ? (k = s.unix(v).startOf("minute").unix(), e[9] = v, e[10] = k) : k = e[10], t = k, n = s.unix(H).startOf("minute").unix(), e[5] = b, e[6] = v, e[7] = t, e[8] = n;
    } else
      t = e[7], n = e[8];
    const i = n;
    let ye;
    if (e[11] !== i || e[12] !== t || e[13] !== T) {
      let H;
      e[15] !== i || e[16] !== t ? (H = (k) => {
        if (k.value === "custom")
          return !0;
        const {
          startDate: rt,
          endDate: it
        } = I(k.value), ut = s.unix(rt).startOf("minute").unix(), ct = s.unix(it).startOf("minute").unix();
        return ut >= t && ct <= i;
      }, e[15] = i, e[16] = t, e[17] = H) : H = e[17], ye = T.filter(H), e[11] = i, e[12] = t, e[13] = T, e[14] = ye;
    } else
      ye = e[14];
    Se = ye;
  }
  const Le = Se;
  let Z;
  e[18] !== Te ? (Z = pt(Te), e[18] = Te, e[19] = Z) : Z = e[19];
  const ee = Z, te = Math.floor((o - r) * tt), ae = M ? "MMM DD, YYYY" : "MMM DD, YYYY hh:mm A";
  let le;
  e[20] !== j ? (le = (t, n, i) => {
    j && j(t, n, i);
  }, e[20] = j, e[21] = le) : le = e[21];
  const u = le;
  let se;
  e[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (se = (t, n) => {
    e: switch (n) {
      case "live-data-preset-menu": {
        Ge(t.currentTarget);
        break e;
      }
      case "custom-time-selector-menu-start":
      case "custom-time-selector-menu-end":
        n === "custom-time-selector-menu-start" ? ge(t.currentTarget) : Je(t.currentTarget), O(!0), y(!1);
    }
    Qe(n);
  }, e[22] = se) : se = e[22];
  const _e = se;
  let ne;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ne = (t) => {
    e: switch (t) {
      case "live-data-preset-menu": {
        Ge(null);
        break e;
      }
      case "custom-time-selector-menu-start": {
        ge(null);
        break e;
      }
      case "custom-time-selector-menu-end":
        ge(null), Je(null);
    }
    Qe(null);
  }, e[23] = ne) : ne = e[23];
  const oe = ne;
  let re;
  e[24] !== o || e[25] !== r || e[26] !== a || e[27] !== u ? (re = (t) => {
    if (t.value === "custom")
      B(t), O(!0), y(!1), u(r, o, t.value);
    else {
      const {
        startDate: n,
        endDate: i
      } = I(t.value);
      D(s(i).tz(a).valueOf()), h(s(n).tz(a).valueOf()), B(t), u(n, i, t.value), O(!1);
    }
    oe(
      "live-data-preset-menu"
      /* LIVE_DATA_PRESET_MENU */
    );
  }, e[24] = o, e[25] = r, e[26] = a, e[27] = u, e[28] = re) : re = e[28];
  const Ae = re;
  let ie;
  e[29] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ie = (t) => {
    B({
      label: "Custom",
      value: "custom"
    }), _e(
      t,
      "custom-time-selector-menu-start"
      /* CUSTOM_TIME_SELECTOR_MENU_START */
    );
  }, e[29] = ie) : ie = e[29];
  const st = ie;
  let ue;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ue = (t) => {
    B({
      label: "Custom",
      value: "custom"
    }), _e(
      t,
      "custom-time-selector-menu-end"
      /* CUSTOM_TIME_SELECTOR_MENU_END */
    );
  }, e[30] = ue) : ue = e[30];
  const nt = ue;
  let ce;
  e[31] !== o || e[32] !== l.value || e[33] !== r || e[34] !== u ? (ce = () => {
    y(!0), u(r, o, l.value);
  }, e[31] = o, e[32] = l.value, e[33] = r, e[34] = u, e[35] = ce) : ce = e[35];
  const Be = ce;
  let me;
  e[36] !== Ce || e[37] !== l.value || e[38] !== a || e[39] !== u ? (me = () => {
    const {
      startDate: t,
      endDate: n
    } = I(l.value);
    h(s(t).tz(a).valueOf()), D(s(n).tz(a).valueOf()), u(t, n, l.value), Ce?.(t, n, l.value);
  }, e[36] = Ce, e[37] = l.value, e[38] = a, e[39] = u, e[40] = me) : me = e[40];
  const Ie = me;
  let de;
  e[41] !== o || e[42] !== b || e[43] !== v || e[44] !== l.value || e[45] !== r || e[46] !== a || e[47] !== u ? (de = (t, n) => {
    const i = n * t;
    t === 1 && o + i > s().unix() || t === -1 && r + i < v || t === 1 && o + i > b || (h(s(r + i).tz(a).valueOf()), D(s(o + i).tz(a).valueOf()), u(r + i, o + i, l.value));
  }, e[41] = o, e[42] = b, e[43] = v, e[44] = l.value, e[45] = r, e[46] = a, e[47] = u, e[48] = de) : de = e[48];
  const fe = de;
  let ve;
  e[49] !== z || e[50] !== o || e[51] !== l.value || e[52] !== r || e[53] !== a || e[54] !== u ? (ve = (t) => {
    if (t > o)
      return;
    z && u(t, o, l.value), h(s(t).tz(a).valueOf());
    const n = s(t).startOf("second").unix(), i = s(r).startOf("second").unix();
    n !== i && (y(!1), O(!0));
  }, e[49] = z, e[50] = o, e[51] = l.value, e[52] = r, e[53] = a, e[54] = u, e[55] = ve) : ve = e[55];
  const Me = ve;
  let he;
  e[56] !== z || e[57] !== o || e[58] !== l.value || e[59] !== r || e[60] !== a || e[61] !== u ? (he = (t) => {
    if (t < r)
      return;
    z && u(r, t, l.value), D(s(t).tz(a).valueOf());
    const n = s(t).startOf("second").unix(), i = s(o).startOf("second").unix();
    n !== i && (y(!1), O(!0));
  }, e[56] = z, e[57] = o, e[58] = l.value, e[59] = r, e[60] = a, e[61] = u, e[62] = he) : he = e[62];
  const ke = he;
  let De;
  e[63] !== x || e[64] !== _ || e[65] !== T || e[66] !== p || e[67] !== a ? (De = () => {
    if (_)
      if (_ === "custom")
        if (B({
          label: "Custom",
          value: "custom"
        }), p && x)
          h(s(p).tz(a).valueOf()), D(s(x).tz(a).valueOf()), y(!0), O(!0);
        else {
          const {
            startDate: t,
            endDate: n
          } = I("7days");
          h(s(t).tz(a).valueOf()), D(s(n).tz(a).valueOf()), y(!0), O(!0);
        }
      else {
        const t = T.find((n) => n.value === _) || {
          label: "Custom",
          value: "custom"
        };
        if (B(t), t.value === "custom")
          if (p && x)
            h(s(p).tz(a).valueOf()), D(s(x).tz(a).valueOf()), y(!0), O(!0);
          else {
            const {
              startDate: n,
              endDate: i
            } = I("7days");
            h(s(n).tz(a).valueOf()), D(s(i).tz(a).valueOf()), y(!0), O(!0);
          }
        else {
          const {
            startDate: n,
            endDate: i
          } = I(t.value);
          h(s(n).tz(a).valueOf()), D(s(i).tz(a).valueOf());
        }
      }
    else if (p && x)
      B({
        label: "Custom",
        value: "custom"
      }), y(!0), O(!0), h(s(p).tz(a).valueOf()), D(s(x).tz(a).valueOf());
    else {
      const {
        startDate: t,
        endDate: n
      } = I("7days");
      h(s(t).tz(a).valueOf()), D(s(n).tz(a).valueOf()), B({
        label: "7 Days",
        value: "7days"
      });
    }
  }, e[63] = x, e[64] = _, e[65] = T, e[66] = p, e[67] = a, e[68] = De) : De = e[68];
  let pe;
  e[69] !== x || e[70] !== _ || e[71] !== T || e[72] !== p || e[73] !== a || e[74] !== u ? (pe = [p, x, _, T, a, u], e[69] = x, e[70] = _, e[71] = T, e[72] = p, e[73] = a, e[74] = u, e[75] = pe) : pe = e[75], ht(De, pe);
  let xe;
  e[76] !== d || e[77] !== l.value || e[78] !== a || e[79] !== u ? (xe = () => {
    if (l.value !== "custom" && d) {
      const {
        startDate: t,
        endDate: n
      } = I(l.value);
      D(s(n).tz(a).valueOf()), h(s(t).tz(a).valueOf()), u(t, n, l.value), y(!0), O(!1);
    }
  }, e[76] = d, e[77] = l.value, e[78] = a, e[79] = u, e[80] = xe) : xe = e[80];
  const ot = xe;
  let be;
  e[81] !== l ? (be = [l], e[81] = l, e[82] = be) : be = e[82], bt(ot, d ? lt : null, !1, be);
  let R;
  e[83] !== g || e[84] !== d || e[85] !== A || e[86] !== f || e[87] !== l.label || e[88] !== l.value ? (R = !g && /* @__PURE__ */ S(C, { sx: [c.dateTimeBox, A && c.activeDateTimeBox, f && c.dateTimeBoxRightBorder], onClick: (t) => _e(
    t,
    "live-data-preset-menu"
    /* LIVE_DATA_PRESET_MENU */
  ), children: [
    /* @__PURE__ */ m(ft, { sx: c.icon }),
    /* @__PURE__ */ m(N, { sx: c.timeLabel, children: l.label }),
    l.value !== "custom" && d && /* @__PURE__ */ S(C, { sx: [c.liveIndicatorBox, !A && {
      backgroundColor: "#EFEFEF"
    }], children: [
      /* @__PURE__ */ m(C, { sx: c.liveDot }),
      /* @__PURE__ */ m(N, { sx: c.liveLabel, children: "LIVE" })
    ] }),
    /* @__PURE__ */ m(vt, { sx: [c.icon, {
      fontSize: "16px"
    }] })
  ] }), e[83] = g, e[84] = d, e[85] = A, e[86] = f, e[87] = l.label, e[88] = l.value, e[89] = R) : R = e[89];
  let E;
  e[90] !== G || e[91] !== ae || e[92] !== te || e[93] !== o || e[94] !== g || e[95] !== $ || e[96] !== d || e[97] !== fe || e[98] !== f || e[99] !== l.value || e[100] !== r || e[101] !== a ? (E = !f && /* @__PURE__ */ S(C, { sx: [c.dateRangeBox, g && c.dateRangeLeftBorder], children: [
    l.value === "custom" && !$ && /* @__PURE__ */ m(Ze, { direction: -1, distance: te, color: c.arrowIcon.color, onSeek: fe }),
    /* @__PURE__ */ S(C, { sx: c.dateBox, children: [
      /* @__PURE__ */ m(N, { onClick: st, sx: c.dateText, children: l.value === "custom" || !d ? s.unix(r).tz(a).format(ae) : `~ ${xt(l.value)} ago` }),
      G === "custom-time-selector-menu-start" && /* @__PURE__ */ m(C, { sx: c.activeDateBorder })
    ] }),
    /* @__PURE__ */ m(N, { sx: c.dateToLabel, children: "to" }),
    /* @__PURE__ */ S(C, { sx: c.dateBox, children: [
      /* @__PURE__ */ m(N, { onClick: nt, sx: c.dateText, children: l.value === "custom" || !d ? s.unix(o).tz(a).format(ae) : "Now" }),
      G === "custom-time-selector-menu-end" && /* @__PURE__ */ m(C, { sx: c.activeDateBorder })
    ] }),
    l.value === "custom" && !$ && /* @__PURE__ */ m(Ze, { direction: 1, distance: te, color: c.arrowIcon.color, onSeek: fe })
  ] }), e[90] = G, e[91] = ae, e[92] = te, e[93] = o, e[94] = g, e[95] = $, e[96] = d, e[97] = fe, e[98] = f, e[99] = l.value, e[100] = r, e[101] = a, e[102] = E) : E = e[102];
  let P;
  e[103] !== R || e[104] !== E ? (P = /* @__PURE__ */ S(C, { sx: c.innerContainer, children: [
    R,
    E
  ] }), e[103] = R, e[104] = E, e[105] = P) : P = e[105];
  let Y;
  e[106] !== z || e[107] !== Be || e[108] !== Ie || e[109] !== ze || e[110] !== d || e[111] !== f || e[112] !== X ? (Y = !f && !z && /* @__PURE__ */ S(C, { children: [
    d && !X && /* @__PURE__ */ m(Ue, { variant: "outlined", sx: c.refreshButton, onClick: Ie, children: "Refresh" }),
    !d || X ? /* @__PURE__ */ m(Ue, { variant: "contained", sx: c.applyButton, onClick: Be, disabled: ze, children: "Apply" }) : null
  ] }), e[106] = z, e[107] = Be, e[108] = Ie, e[109] = ze, e[110] = d, e[111] = f, e[112] = X, e[113] = Y) : Y = e[113];
  let F;
  e[114] !== Le || e[115] !== Ae || e[116] !== g || e[117] !== d || e[118] !== A || e[119] !== f || e[120] !== l ? (F = !g && /* @__PURE__ */ m(Re, { menuId: "live-data-preset-menu", anchorEl: A, open: !!A, onClose: () => oe(
    "live-data-preset-menu"
    /* LIVE_DATA_PRESET_MENU */
  ), menuWidth: 360, children: /* @__PURE__ */ m(Dt, { presetOptions: Le, activePreset: l, onPresetChange: Ae, isLive: d, isRangeOnly: f }) }), e[114] = Le, e[115] = Ae, e[116] = g, e[117] = d, e[118] = A, e[119] = f, e[120] = l, e[121] = F) : F = e[121];
  let w;
  e[122] !== o || e[123] !== q || e[124] !== ke || e[125] !== Me || e[126] !== M || e[127] !== b || e[128] !== v || e[129] !== f || e[130] !== r || e[131] !== V || e[132] !== ee ? (w = !f && /* @__PURE__ */ S(mt, { children: [
    /* @__PURE__ */ m(Re, { menuId: "custom-time-selector-menu-start", anchorEl: V, open: !!V, onClose: () => oe(
      "custom-time-selector-menu-start"
      /* CUSTOM_TIME_SELECTOR_MENU_START */
    ), menuWidth: M ? 280 : 420, children: /* @__PURE__ */ m(Xe, { date: r, setDate: Me, dateType: "start", timeSlots: ee, isTimeHidden: M, minTime: v, maxTime: b, startDate: r, endDate: o }) }),
    /* @__PURE__ */ m(Re, { menuId: "custom-time-selector-menu-end", anchorEl: q, open: !!q, onClose: () => oe(
      "custom-time-selector-menu-end"
      /* CUSTOM_TIME_SELECTOR_MENU_END */
    ), menuWidth: M ? 280 : 420, children: /* @__PURE__ */ m(Xe, { date: o, setDate: ke, dateType: "end", timeSlots: ee, isTimeHidden: M, minTime: v, maxTime: b, startDate: r, endDate: o }) })
  ] }), e[122] = o, e[123] = q, e[124] = ke, e[125] = Me, e[126] = M, e[127] = b, e[128] = v, e[129] = f, e[130] = r, e[131] = V, e[132] = ee, e[133] = w) : w = e[133];
  let Oe;
  return e[134] !== P || e[135] !== Y || e[136] !== F || e[137] !== w ? (Oe = /* @__PURE__ */ S(C, { sx: c.container, children: [
    P,
    Y,
    F,
    w
  ] }), e[134] = P, e[135] = Y, e[136] = F, e[137] = w, e[138] = Oe) : Oe = e[138], Oe;
};
export {
  Et as DateTimeSelector
};
